export const EVENT_DIMENSION_NAME = 'Events Category';
